/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfReportsV1ReportState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_REPORTS_V1_REPORT_STATE_ENTITY_NAME = 'ixf.reports.v1.Report';
export const ixfReportsV1ReportStateEntity = new schema.Entity<IxfReportsV1ReportState>(IXF_REPORTS_V1_REPORT_STATE_ENTITY_NAME, {}, { idAttribute: 'reportId' });

